import { useState, useEffect } from 'react';

const useWindowSize = () => {
	const [device, setDevice] = useState('desktop');

	const [windowSize, setWindowSize] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	useEffect(() => {
		const handleResize = () => {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (windowSize.width < 768) {
			setDevice('mobile');
		} else {
			setDevice('desktop');
		}
	}, [windowSize]);

	return device;
};

export default useWindowSize;
